import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-overview__wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "step-highlight"
}
const _hoisted_3 = { class: "joy-panel" }
const _hoisted_4 = { class: "joy-panel__header" }
const _hoisted_5 = { class: "joy-panel__title" }
const _hoisted_6 = { class: "joy-panel__body" }
const _hoisted_7 = { class: "step-row__subtitle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  href: "#",
  "aria-hidden": ""
}
const _hoisted_10 = { class: "step-row__subtitle-level" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  href: "#",
  "aria-hidden": ""
}
const _hoisted_13 = { class: "step-row__subtitle" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  href: "#",
  "aria-hidden": ""
}
const _hoisted_16 = { class: "joy-panel step-row-condition" }
const _hoisted_17 = { class: "joy-panel__header" }
const _hoisted_18 = { class: "joy-panel__title" }
const _hoisted_19 = { class: "joy-panel__body" }
const _hoisted_20 = { class: "step-row--block" }
const _hoisted_21 = { class: "step-row--block" }
const _hoisted_22 = { class: "joy-panel" }
const _hoisted_23 = { class: "step__title" }
const _hoisted_24 = { class: "step__subtitle" }
const _hoisted_25 = { class: "step__subtitle" }
const _hoisted_26 = { class: "step-row__description" }
const _hoisted_27 = {
  key: 2,
  class: "step-highlight"
}
const _hoisted_28 = { class: "joy-panel redirect" }
const _hoisted_29 = {
  key: 2,
  class: "redirect"
}

import {computed, inject, nextTick, onMounted, ref, watch} from 'vue';
    import {useStore} from 'vuex';
    import {useRoute, useRouter} from 'vue-router';
    import {getPageLocale, scrollToTarget} from '@malt/dom';
    import {useGlobalProperties, useVueInternals} from '@malt/vue3-use';
    import {DI} from '@/brief-hub/config/DependencyInjection';
    import {BriefOrigin, BriefWorkingStatus, ClientIdentity, PhoneValidationStatus} from '@/common/api/api-raw-types';
    import {ActionsType} from '@/brief-hub/store/modules/brief/actions';
    import {RouteNames} from '@/brief-hub/router/route-names';
    import {UserService} from '@/brief-hub/user/UserService';
    import {Payload} from '@/brief-hub/store/modules/brief/types';
    import {MutationsType} from '@/brief-hub/store/modules/brief/mutations';
    import {useBriefConditions} from '@/brief-hub/brief/useBriefConditions';
    import UserResource from '@/brief-hub/user/UserResource';
    import PhoneNumberCompletionDialog from '@/common/components/PhoneNumberCompletionDialog.vue';
    import {BriefTrackingService} from '@/brief-hub/brief/BriefTrackingService';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
    import {useHotjar} from '@/brief-hub/common/utils/useHotjar';
    import CompanySelector, {Company} from '@/brief-hub/deposit/overview/CompanySelector.vue';
    import BriefOverviewTipsV2 from '@/brief-hub/deposit/overview/BriefOverviewTipsV2.vue';
    import StepRowCell from '@/brief-hub/deposit/overview/StepRowCell.vue';
    import StepRowTags from '@/brief-hub/deposit/overview/StepRowTags.vue';
    import BriefHubStepLayout from '@/brief-hub/common/ui/layout/BriefHubStepLayout.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BriefOverview',
  setup(__props) {

    const JOB_DESC_ORIGINS = [BriefOrigin.INFERENCE_PROMPT, BriefOrigin.JOB_DESCRIPTION_TEXT, BriefOrigin.JOB_DESCRIPTION_PDF];

    const store = useStore();
    const {$msg, $requireMsg, $features} = useGlobalProperties();
    const {proxy} = useVueInternals();
    const router = useRouter();
    const route = useRoute();
    const hotjar = useHotjar();

    $requireMsg('customer.brief.form.overview.*');

    const isPhoneNumberCompletionDialogOpen = ref<boolean>(false);

    const userService = inject<UserService>(DI.userService)!;
    const briefTrackingService = inject<BriefTrackingService>(DI.briefTrackingService);

    const brief = store.getters.brief;
    const connectedUser = computed((): UserResource => store.getters.connectedUser!);
    const briefUser = ref<UserResource>();
    const clientUser = computed((): UserResource => briefUser.value || connectedUser.value);

    const companies = ref<Company[]>([]);

    const selectedCompanyId = ref(brief.companyId || '');
    const submitting = ref(false);

    const subtitle = computed((): string => {
        return selectedCompany.value?.maltPlusBetaOnly === false
            ? $msg('customer.brief.form.overview.subtitle.v3')
            : $msg('customer.brief.form.overview.subtitle.v3.beta');
    });

    const experienceLevelTranslate = computed((): string => {
        const currentLevel = brief.profileDetails.experienceLevel;
        return $msg(`customer.brief.form.overview.freelancer.profile.level.${currentLevel}`);
    });

    const identityOfCompanyId = computed((): string => {
        if (clientUser.value && clientUser.value.clientIdentities) {
            return clientUser.value.clientIdentities
                .filter((identity) => identity.companyId === selectedCompanyId.value)
                .map((identity) => identity.identityId)[0];
        }
        return '';
    });

    const selectedCompany = computed((): Company | null => companies.value.find((company) => company.id === selectedCompanyId.value) || null);

    const briefDetails = computed(() => brief.briefDetails);
    const anotherCompany = computed((): boolean => identityOfCompanyId.value !== clientUser.value.identityId);

    const isJobDescOrigin = computed((): boolean => JOB_DESC_ORIGINS.includes(brief.origin));
    const anonymous = computed((): boolean => !clientUser.value);
    const allowSubmit = computed((): boolean => !submitting.value && (!!selectedCompanyId.value || anonymous.value));
    const userHasMultipleIdentities = computed((): boolean => companies.value && companies.value.length > 1);
    const skills = computed(() => brief.profileDetails.freelancerSkills);
    const languages = computed(() => brief.profileDetails.languages.map((language) => language.label));

    const {duration, startDate, budget, freelancerAvailability, dailyFreelancerRate, isDurationMoreThanOneMonth, city, remote} = useBriefConditions(
        briefDetails.value,
        getPageLocale(),
    );

    const userMustUpgrade = computed((): boolean => !connectedUser.value || connectedUser.value?.serviceLevelType === 'STANDARD');

    const isAdvancedOrStarterUser = computed(
        (): boolean => connectedUser.value?.serviceLevelType === 'ADVANCED' || connectedUser.value?.serviceLevelType === 'STANDARD',
    );

    function backToEdit(routeName: string): void {
        router.push({
            name: routeName,
            params: {id: brief.briefId},
        });
    }

    onMounted(async () => {
        briefTrackingService?.triggerBriefFunnelStepEnteredAmplitudeEvent('overview', 6, route);

        if (isJobDescOrigin.value) {
            hotjar.publishEvent('job_desc_brief_submitted');
        }

        if (connectedUser.value?.maltAdmin) {
            const [user] = await userService.fetchBriefClient(brief.links.allUserInfos(), brief.identityId);
            briefUser.value = user || undefined;
        }

        if (!route.params.link) {
            return;
        }

        await nextTick();
        const $element = proxy?.$refs[route.params.link as string] as HTMLElement;
        if ($element) {
            await nextTick();
            scrollToTarget($element);
        }
    });

    function logUserWithSelectedIdentity(): void {
        // we want to make sure the button is disabled during the post of the identity selection form
        submitting.value = true;
        userService.redirectToIdentity(identityOfCompanyId.value, `/customer/searches/${brief.briefId}/details`);
    }

    async function submitBrief(): Promise<void> {
        if ($features.projectProposalBriefNoMoreServiceLevelNeeded && !connectedUser.value) {
            submitting.value = true;
            window.location.href = `/customer/searches/draft/${brief.briefId}/signup-submit`;
            return;
        }
        const [phoneStatus, e] = await context.httpService.get<PhoneValidationStatus>(context.registry.entries.getPhoneStatus());

        if (phoneStatus === PhoneValidationStatus.PHONE_NUMBER_MISSING) {
            isPhoneNumberCompletionDialogOpen.value = true;
            return;
        }

        if (e) {
            console.error(e);
            pushVJoySnackbar({props: {message: $msg('customer.brief.error.unknown'), level: 'error'}});
            return;
        }

        submitting.value = true;

        const [, error] = await store.dispatch(ActionsType.SUBMIT_BRIEF);
        submitting.value = false;

        if (error) {
            if (error.response && error.response.status === 401 && error.response.data && error.response.data.redirectUrl) {
                window.location.href = error.response.data.redirectUrl;
                return;
            }
            pushVJoySnackbar({
                props: {
                    header: $msg('customer.brief.error.can.not.be.submitted.header'),
                    message:
                        error.response && error.response.status === 400
                            ? $msg('customer.brief.error.can.not.be.submitted')
                            : $msg('customer.brief.error.unknown'),
                    level: 'error',
                },
            });
        } else {
            postBriefSubmissionActions();
        }
    }

    async function upgradeServiceLevel(): Promise<void> {
        if (isAdvancedOrStarterUser.value) {
            const [phoneStatus, e] = await context.httpService.get<PhoneValidationStatus>(context.registry.entries.getPhoneStatus());

            if (phoneStatus === PhoneValidationStatus.PHONE_NUMBER_MISSING) {
                isPhoneNumberCompletionDialogOpen.value = true;
                return;
            }

            if (e) {
                console.error(e);
                pushVJoySnackbar({props: {message: $msg('customer.brief.error.unknown'), level: 'error'}});
                return;
            }
        }

        if (anonymous.value) {
            window.location.href = brief.links.signupSubmit();
            return Promise.resolve();
        }

        if (userMustUpgrade.value) {
            window.location.href = brief.links.goToServiceLevel();
            return Promise.resolve();
        }
    }

    async function postBriefSubmissionActions() {
        if (anotherCompany.value && !connectedUser.value.maltAdmin) {
            // Client has selected another company for this brief. We need to log current user with this selected identity.
            // If we dont, we won't be able to see created brief because this brief is attached to this selected identity.
            await logUserWithSelectedIdentity();
        } else {
            pushVJoySnackbar({props: {message: $msg('customer.brief.form.submitted'), level: 'success'}});

            const urlParams = new URLSearchParams();
            urlParams.append('entry_point', 'brief-submission');
            if (isJobDescOrigin.value && connectedUser.value.maltAdmin) {
                urlParams.append('hotjarSurveyJobDesc', 'true');
            }

            if (connectedUser.value.maltAdmin) {
                window.location.href = `/client/sourcing-projects/${brief.briefId}/search?${urlParams.toString()}`;
            } else {
                window.location.href = `/client/sourcing-projects/${brief.briefId}?${urlParams.toString()}`;
            }
        }
    }

    watch(
        clientUser,
        () => {
            if (!clientUser.value) {
                return;
            }

            if (clientUser.value.clientIdentities) {
                companies.value = getCompanies(clientUser.value.clientIdentities);
            }
        },
        {immediate: true},
    );

    function getCompanies(clientIdentities: ClientIdentity[]): Company[] {
        return clientIdentities.map((identity) => {
            const selectable = identity.maltPlusAvailable || identity.maltPlusBetaAvailable;
            const name = selectable ? identity.companyName : `${identity.companyName} ${$msg('customer.brief.form.overview.company.unselectable')}`;
            return {
                id: identity.companyId,
                name,
                selectable,
                maltPlusBetaOnly: identity.maltPlusBetaAvailable,
            };
        });
    }

    watch(
        [identityOfCompanyId, selectedCompanyId],
        () => {
            let payload: Payload | null = null;
            if (selectedCompanyId.value) {
                payload = {
                    type: 'BriefSubmissionRequest',
                    payload: {
                        identityId: identityOfCompanyId.value,
                    },
                };
            }
            store.commit(MutationsType.UPDATE_PAYLOAD, payload);
        },
        {immediate: true},
    );

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!
  const _component_VJoyTag = _resolveComponent("VJoyTag")!
  const _component_VJoyHighlight = _resolveComponent("VJoyHighlight")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BriefHubStepLayout, { "has-footer": false }, {
      right: _withCtx(() => [
        _createVNode(BriefOverviewTipsV2)
      ]),
      default: _withCtx(() => [
        (_unref(brief))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (isJobDescOrigin.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                    _createVNode(_component_VJoyWrapper, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_VJoyHighlight, {
                          variant: "ai",
                          accent: true
                        }, {
                          "highlight-decorator": _withCtx(() => [
                            _createVNode(_component_VJoyTag, { variant: "ai-primary" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VJoyIcon, { name: "sparkle" }),
                                _createTextVNode(" " + _toDisplayString(_unref($msg)('generic.ai')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_unref($msg)('customer.brief.form.topAiHighlight.text')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("header", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref($msg)('customer.brief.form.overview.profile.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    ref: "briefFreelancerProfile",
                    class: "step-row__back",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (backToEdit(_unref(RouteNames).BRIEF_FREELANCER_PROFILE)))
                  }, [
                    _createVNode(_component_VJoyButton, {
                      icon: "pen",
                      circle: "",
                      size: "small",
                      variant: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      (_unref(brief).profileDetails.freelancerRequiredCategories[0]?.label)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(brief).profileDetails.freelancerRequiredCategories[0].label), 1))
                        : (_openBlock(), _createElementBlock("a", _hoisted_9, _toDisplayString(_unref($msg)('generic.form.add.label')), 1)),
                      _createElementVNode("span", _hoisted_10, [
                        _cache[9] || (_cache[9] = _createTextVNode(" - ")),
                        (experienceLevelTranslate.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(experienceLevelTranslate.value), 1))
                          : (_openBlock(), _createElementBlock("a", _hoisted_12, _toDisplayString(_unref($msg)('generic.form.add.label')), 1))
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", {
                    ref: _unref($features).ff4JBriefFunnelUpdateCategorySuggestion ? 'briefFreelancerProfile' : 'briefFreelancerJobTitle',
                    class: "step-row__back",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                                backToEdit(
                                    _unref($features).ff4JBriefFunnelUpdateCategorySuggestion
                                        ? _unref(RouteNames).BRIEF_FREELANCER_PROFILE
                                        : _unref(RouteNames).BRIEF_FREELANCER_JOB_TITLE,
                                )
                            ))
                  }, [
                    _createVNode(_component_VJoyButton, {
                      icon: "pen",
                      circle: "",
                      size: "small",
                      variant: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      (_unref(brief).profileDetails.freelancerJobTitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(brief).profileDetails.freelancerJobTitle), 1))
                        : (_openBlock(), _createElementBlock("a", _hoisted_15, _toDisplayString(_unref($msg)('generic.form.add.label')), 1))
                    ])
                  ], 512),
                  _createElementVNode("div", {
                    ref: "briefFreelancerSkills",
                    class: "step-row__back",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (backToEdit(_unref(RouteNames).BRIEF_FREELANCER_SKILLS)))
                  }, [
                    _createVNode(_component_VJoyButton, {
                      icon: "pen",
                      circle: "",
                      size: "small",
                      variant: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(StepRowTags, {
                      label: _unref($msg)('customer.brief.form.overview.skills.title'),
                      tags: skills.value,
                      mandatory: true
                    }, null, 8, ["label", "tags"]),
                    (_unref(brief).profileDetails.languages.length > 0)
                      ? (_openBlock(), _createBlock(StepRowTags, {
                          key: 0,
                          label: _unref($msg)('customer.brief.form.overview.3.profile.3.languages.label'),
                          tags: languages.value,
                          variant: "secondary",
                          mandatory: true
                        }, null, 8, ["label", "tags"]))
                      : _createCommentVNode("", true)
                  ], 512)
                ])
              ]),
              _createElementVNode("section", _hoisted_16, [
                _createElementVNode("header", _hoisted_17, [
                  _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref($msg)('customer.brief.form.overview.conditions.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    ref: "briefWhenConditions",
                    class: "step-row__back",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (backToEdit(_unref(RouteNames).BRIEF_WHEN_CONDITIONS)))
                  }, [
                    _createVNode(_component_VJoyButton, {
                      icon: "pen",
                      circle: "",
                      size: "small",
                      variant: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(StepRowCell, {
                        label: _unref($msg)('customer.brief.conditions.when.duration'),
                        value: _unref(duration),
                        mandatory: true
                      }, null, 8, ["label", "value"]),
                      _createVNode(StepRowCell, {
                        label: _unref($msg)('customer.brief.conditions.when.start'),
                        value: _unref(startDate)
                      }, null, 8, ["label", "value"]),
                      (_unref(isDurationMoreThanOneMonth)())
                        ? (_openBlock(), _createBlock(StepRowCell, {
                            key: 0,
                            label: _unref($msg)('customer.brief.conditions.when.frequency'),
                            value: _unref(freelancerAvailability)
                          }, null, 8, ["label", "value"]))
                        : (_openBlock(), _createBlock(StepRowCell, {
                            key: 1,
                            label: _unref($msg)('customer.brief.conditions.when.budget'),
                            value: _unref(budget)
                          }, null, 8, ["label", "value"])),
                      (_unref(isDurationMoreThanOneMonth)())
                        ? (_openBlock(), _createBlock(StepRowCell, {
                            key: 2,
                            label: _unref($msg)('customer.brief.conditions.when.daily.rate'),
                            value: _unref(dailyFreelancerRate),
                            mandatory: true
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 512),
                  _createElementVNode("div", {
                    ref: "briefWhereConditions",
                    class: "step-row__back",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (backToEdit(_unref(RouteNames).BRIEF_WHERE_CONDITIONS)))
                  }, [
                    _createVNode(_component_VJoyButton, {
                      icon: "pen",
                      circle: "",
                      size: "small",
                      variant: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(StepRowCell, {
                        label: _unref($msg)('customer.brief.conditions.where.remote'),
                        value: _unref(remote)
                      }, null, 8, ["label", "value"]),
                      (briefDetails.value.workingStatus !== _unref(BriefWorkingStatus).REMOTELY)
                        ? (_openBlock(), _createBlock(StepRowCell, {
                            key: 0,
                            label: _unref($msg)('customer.brief.conditions.where.address'),
                            value: _unref(city),
                            mandatory: true
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 512)
                ])
              ]),
              _createElementVNode("section", _hoisted_22, [
                _createElementVNode("h2", _hoisted_23, _toDisplayString(_unref($msg)('customer.brief.form.overview.mission.title')), 1),
                _createElementVNode("div", {
                  ref: "briefMissionTitle",
                  class: "step-row__back",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (backToEdit(_unref(RouteNames).BRIEF_MISSION_DESCRIPTION)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_unref($msg)('customer.brief.form.overview.mission.subject')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(brief).briefDetails.title), 1)
                ], 512),
                _createElementVNode("div", {
                  ref: "briefMissionDescription",
                  class: "step-row__back",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (backToEdit(_unref(RouteNames).BRIEF_MISSION_DESCRIPTION)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($msg)('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_unref($msg)('customer.brief.form.overview.mission.description')), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(brief).briefDetails.description), 1)
                ], 512)
              ]),
              (!anonymous.value)
                ? (_openBlock(), _createBlock(CompanySelector, {
                    key: 1,
                    modelValue: selectedCompanyId.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedCompanyId).value = $event)),
                    companies: companies.value
                  }, null, 8, ["modelValue", "companies"]))
                : _createCommentVNode("", true),
              (isJobDescOrigin.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                    _createVNode(_component_VJoyWrapper, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_VJoyHighlight, {
                          variant: "ai",
                          accent: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.bottomAiHighlight.text')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_28, [
                (!_unref($features).projectProposalBriefNoMoreServiceLevelNeeded && userMustUpgrade.value)
                  ? (_openBlock(), _createBlock(_component_VJoyButton, {
                      key: 0,
                      variant: "main",
                      "data-testid": "Brief-overview-footer_upgrade-btn",
                      onClick: upgradeServiceLevel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.overview.launch.project.cta.upgrade')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_VJoyButton, {
                      key: 1,
                      variant: "main",
                      disabled: !allowSubmit.value,
                      "data-testid": "Brief-overview-footer_submit-btn",
                      onClick: submitBrief
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.overview.launch.project.cta')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])),
                (userHasMultipleIdentities.value && anotherCompany.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref($msg)('customer.brief.form.overview.company.redirection')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isAdvancedOrStarterUser.value)
      ? (_openBlock(), _createBlock(PhoneNumberCompletionDialog, {
          key: 0,
          open: isPhoneNumberCompletionDialogOpen.value,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (isPhoneNumberCompletionDialogOpen.value = false)),
          onConfirm: submitBrief
        }, null, 8, ["open"]))
      : _createCommentVNode("", true)
  ]))
}
}

})